
import user from './interface/user'
import home from './interface/home';
import order from './interface/order';
import personCenter from './interface/personCenter';
import tools from './interface/tools';
import company from './interface/company';
import test from './interface/test';
export default {
  user,
  home,
  order,
  personCenter,
  tools,
  company,
  test
}
